export const GET_ASSETS = "GET_ASSETS";
export const RESET_ASSETS = "RESET_ASSETS";
export const SET_ASSETS_REQUEST_STATUS = "SET_ASSETS_REQUEST_STATUS";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const DELETE_ASSETS = "DELETE_ASSETS";
export const CREATE_ASSET = "CREATE_ASSET";
export const SET_FILTERED_ASSETS = "SET_FILTERED_ASSETS";
